import request from '@/utils/request'

// 查询社区活动关联小组列表
export function listCommunityGroupActivityRelation(query) {
  return request({
    url: '/biz/admin/community/community/group/activity/relation/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询社区活动关联小组分页
export function pageCommunityGroupActivityRelation(query) {
  return request({
    url: '/biz/admin/community/community/group/activity/relation/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询社区活动关联小组详细
export function getCommunityGroupActivityRelation(data) {
  return request({
    url: '/biz/admin/community/community/group/activity/relation/detail',
    method: 'get',
    params: data
  })
}

// 新增社区活动关联小组
export function addCommunityGroupActivityRelation(data) {
  return request({
    url: '/biz/admin/community/community/group/activity/relation/add',
    method: 'post',
    data: data
  })
}

// 修改社区活动关联小组
export function updateCommunityGroupActivityRelation(data) {
  return request({
    url: '/biz/admin/community/community/group/activity/relation/edit',
    method: 'post',
    data: data
  })
}

// 删除社区活动关联小组
export function delCommunityGroupActivityRelation(data) {
  return request({
    url: '/biz/admin/community/community/group/activity/relation/delete',
    method: 'post',
    data: data
  })
}
